import disabledStatus from './disabled-status';

export default {
  disabledStatus,
};
